import { Link } from 'react-router-dom';
import styled from 'styled-components';
import theme from '@styles/theme';

export const LoginForm = styled.form`
    margin: 150px auto;
    width: 343px;
`;
export const Title = styled.h2`
    margin-bottom: 20px;
    font-size: 24px;
    font-family: PretendardMedium, sans-serif;
    text-align: center;
`;
export const SubTitle = styled.div`
    margin-bottom: 40px;
    font-size: 14px;
    color: ${theme.colors.grayIconColor};
    text-align: center;
`;
export const LinkButton = styled(Link)`
    position: relative;
    font-size: 14px;
    text-align: right;
    color: ${theme.colors.grayIconColor};
    &:last-of-type {
        padding-left: 17px;
        &::before {
            content: '';
            position: absolute;
            top: 4px;
            left: 0;
            display: inline-block;
            width: 1px;
            height: 14px;
            background-color: ${theme.colors.grayIconColor};
            margin: 0 8px;
        }
    }
`;
